import { buildMessage, registerDecorator } from 'class-validator';
import { DateTime } from 'luxon';
export function isTimeZoneFormat(value) {
    return !!value && DateTime.local().setZone(value).isValid;
}
export function IsDateTimeZone(validationOptions) {
    return (object, propertyName) => {
        registerDecorator({
            name: isTimeZoneFormat.name,
            target: object.constructor,
            propertyName: propertyName.toString(),
            constraints: [],
            options: validationOptions,
            validator: {
                validate: isTimeZoneFormat,
                defaultMessage: buildMessage((eachPrefix) => {
                    return `${eachPrefix}$property must be valid timezone.`;
                }, validationOptions),
            },
        });
    };
}
//# sourceMappingURL=IsDateTimeZone.js.map